import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
export default function AuthorsAndEditorsDelimiter(t0) {
  const $ = _c(2);
  const {
    index,
    size
  } = t0;
  if (index + 1 >= size) {
    return null;
  }
  let text;
  if (index + 2 < size) {
    text = ",";
  } else {
    if (index + 1 < size) {
      text = "and";
    }
  }
  let t1;
  if ($[0] !== text) {
    t1 = <Typography variant="textSmall" color="text.secondary" paddingX={1}>{text}</Typography>;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}